/**
 * @generated SignedSource<<28effc076feacdd130b29906b0e7d022>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_user" | "PdpSharedSidebarItemReturns_user">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_user";
};
export type PdpRespSidebarBlurbs_user$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_user"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSidebarItemReturns_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "97816f3291fd2131af9cf9e39d214cf2";

export default node;
